<template>
    <v-dialog
        v-model="$store.state.order.rdnAdd"
        max-width="1900px"
        transition="dialog-transition"
        persistent
    >
        <dynamic-toolbar
            :title="
                'New Order Creation - ' +
                    DateRange.End.Date +
                    ' ' +
                    DateRange.End.Shift
            "
            color="indigo"
            icon="mdi-invoice-text-plus"
            theme="dark"
            v-if="CurrentUser == 'glarivee' || CurrentUser == 'fchavarin'"
        >
            <template #buttons>
                <v-btn
                    color="#fff"
                    small
                    icon
                    dark
                    @click="$store.state.order.rdnAdd = false"
                >
                    <v-icon left>mdi-close</v-icon>
                </v-btn>
            </template>
        </dynamic-toolbar>
        <template
            v-if="CurrentUser == 'glarivee' || CurrentUser == 'fchavarin'"
        >
            <v-stepper v-model="newAssignment.currentStep" vertical>
                <v-stepper-step
                    :complete="newAssignment.currentStep > 1"
                    step="1"
                >
                    Select a driver and a shift
                    <small
                        >Select the driver who will carry out the order</small
                    >
                </v-stepper-step>
                <v-stepper-content step="1">
                    <v-card outlined class="mb-12" height="220px">
                        <v-card-title style="padding: 30px;">
                            <span class="headline" style="margin-right: 10px;"
                                >Shift Assignment</span
                            >
                            <strong class="headline">{{
                                DateRange.End.Date + ' ' + DateRange.End.Shift
                            }}</strong>
                        </v-card-title>
                        <v-card-text>
                            <v-card outlined class="mb-4">
                                <v-card-text>
                                    <v-row>
                                        <!-- <v-col cols="3">
                                            <v-autocomplete
                                                v-model="newAssignment.driverSelected"
                                                :items="newAssignment.collections.drivers"
                                                dense
                                                item-value="DriverID"
                                                item-text="Name"
                                                label="Driver"
                                                outlined
                                            ></v-autocomplete>
                                        </v-col> -->
                                        <v-col cols="4">
                                            <v-autocomplete
                                                v-model="
                                                    newAssignment.shiftSelected
                                                "
                                                :items="
                                                    newAssignment.collections
                                                        .shifts
                                                "
                                                dense
                                                item-value="ShiftDetail"
                                                item-text="DriverName"
                                                label="Driver"
                                                return-object
                                                outlined
                                                :loading="loading.newAssignment"
                                            ></v-autocomplete>
                                        </v-col>
                                        <v-col cols="4">
                                            <v-text-field
                                                v-model="
                                                    newAssignment.shiftSelected
                                                        .Truck
                                                "
                                                label="Truck"
                                                readonly
                                                outlined
                                                dense
                                                hide-details
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="4">
                                            <v-text-field
                                                v-model="
                                                    newAssignment.shiftSelected
                                                        .Trailer
                                                "
                                                label="Tailer"
                                                readonly
                                                outlined
                                                dense
                                                hide-details
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-card-text>
                    </v-card>
                    <v-btn color="indigo" outlined @click="loadTrailerInfo">
                        Continue
                        <v-icon>mdi-arrow-right</v-icon>
                    </v-btn>
                    <v-btn
                        text
                        @click="$store.state.order.rdnAdd = false"
                        color="indigo"
                        style="margin: 0 10px;"
                    >
                        Cancel
                    </v-btn>
                </v-stepper-content>

                <v-stepper-step
                    :complete="newAssignment.currentStep > 2"
                    step="2"
                >
                    Set order quantities
                </v-stepper-step>

                <v-stepper-content step="2">
                    <v-card
                        class="mb-12"
                        height="100%"
                        style="padding-bottom: 10px;"
                    >
                        <trailerView
                            v-if="$store.state.dispatch.canvas"
                            :isModalView="false"
                        ></trailerView>
                        <SiteReadings
                            :valores="parmsDT"
                            ref="siteRef"
                            style="margin-top: 0px; padding-top: 0px"
                        />
                        <v-card-text style="margin: 10px 0;">
                            <v-toolbar dense dark color="secondary">
                                <v-spacer></v-spacer>
                                <v-toolbar-title class="white--text">
                                    Order Info
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                            <v-row class="mx-5 mt-5">
                                <div class="tm">
                                    <v-text-field
                                        dense
                                        v-model="orderID"
                                        label="OrderID"
                                        v-if="$store.state.editedOrder.id"
                                        disabled
                                        class="mx-3"
                                    ></v-text-field>
                                </div>
                                <div class="tm">
                                    <v-text-field
                                        dense
                                        v-model="editedItem.OrderStatus"
                                        label="Order Status"
                                        v-if="$store.state.editedOrder.id"
                                        class="mx-3"
                                        disabled
                                    ></v-text-field>
                                </div>
                                <div class="tm">
                                    <v-text-field
                                        dense
                                        v-model="editedItem.DateOrdered"
                                        label="Order Date"
                                        class="mx-3"
                                        disabled
                                    ></v-text-field>
                                </div>
                                <div class="tm">
                                    <v-text-field
                                        dense
                                        v-model="editedItem.TimeOrdered"
                                        label="Order Time"
                                        class="mx-3"
                                        disabled
                                    ></v-text-field>
                                </div>
                            </v-row>
                            <v-form ref="form" lazy-validation>
                                <v-row class="mx-5">
                                    <div class="tm">
                                        <v-combobox
                                            dense
                                            hide-details
                                            required
                                            v-model="editedItem.Station"
                                            :items="stations"
                                            :item-text="'Name'"
                                            :item-value="'id'"
                                            label="Station"
                                            :rules="[
                                                v =>
                                                    !!v || 'Station is required'
                                            ]"
                                            class="mx-3"
                                            auto-select-first
                                            @change="getStationInfo()"
                                        ></v-combobox>
                                    </div>
                                    <div class="tm">
                                        <v-combobox
                                            dense
                                            hide-details
                                            required
                                            v-model="editedItem.Customer"
                                            :items="customers"
                                            :item-text="'Name'"
                                            :item-value="'id'"
                                            label="Customer"
                                            :rules="[
                                                v =>
                                                    !!v ||
                                                    'Customer is required '
                                            ]"
                                            class="mx-3"
                                            auto-select-first
                                        ></v-combobox>
                                        <v-row>
                                            <v-text-field
                                                label="Ship To"
                                                id="ShipTo"
                                                v-model="editedItem.ShipTo"
                                                :value="editedItem.ShipTo"
                                            ></v-text-field>
                                        </v-row>
                                    </div>
                                    <div class="tm">
                                        <v-combobox
                                            dense
                                            hide-details
                                            required
                                            v-model="editedItem.Terminal"
                                            :items="terminals"
                                            :item-text="'Name'"
                                            :item-value="'id'"
                                            :rules="[
                                                v =>
                                                    !!v ||
                                                    'Terminal is required'
                                            ]"
                                            label="Terminal"
                                            @click:append-outer="savePrimary"
                                            append-outer-icon="mdi-content-save"
                                            class="mx-3"
                                            auto-select-first
                                        ></v-combobox>
                                    </div>
                                    <div class="tm">
                                        <v-combobox
                                            dense
                                            hide-details
                                            required
                                            v-model="editedItem.Supplier"
                                            :items="suppliers"
                                            :item-text="'Supplier'"
                                            :rules="[
                                                v =>
                                                    !!v ||
                                                    'Supplier is required'
                                            ]"
                                            :item-value="'id'"
                                            label="Supplier"
                                            class="mx-3"
                                            auto-select-first
                                        ></v-combobox>
                                        <v-row class="mx-1">
                                            <v-checkbox
                                                style="margin-top: 40px;"
                                                class="mx-3"
                                                large
                                                label="On Price"
                                                v-model="editedItem.onPrice"
                                            ></v-checkbox>
                                            <v-checkbox
                                                style="margin-top: 40px;"
                                                disabled
                                                class="mx-3"
                                                large
                                                label="Split CK"
                                                v-model="
                                                    editedItem.SplitApprovedCK
                                                "
                                            ></v-checkbox>
                                            <v-checkbox
                                                style="margin: 0;"
                                                class="mx-3"
                                                large
                                                label="Set Automatic Quantities"
                                                v-model="
                                                    editedItem.AutomaticCreation
                                                "
                                            ></v-checkbox>
                                        </v-row>
                                    </div>
                                </v-row>
                            </v-form>
                            <v-row class="mx-5">
                                <div class="tm">
                                    <v-text-field
                                        class="mx-3"
                                        label="Loading Number"
                                        v-model="editedItem.LoadingNumber"
                                    ></v-text-field>
                                </div>
                                <div class="tm">
                                    <v-text-field
                                        label="Requested Date"
                                        id="DateRequested"
                                        :value="editedItem.DateRequested"
                                        v-mask="'####/##/## ##:##'"
                                        :rules="dateRules"
                                        type="tel"
                                    ></v-text-field>
                                </div>
                                <div class="tm">
                                    <v-text-field
                                        class="mx-3"
                                        label="Created By"
                                        disabled
                                    ></v-text-field>
                                </div>
                            </v-row>
                            <v-row class="mx-5">
                                <div class="tm2">
                                    <v-combobox
                                        dense
                                        hide-details
                                        v-model="editedItem.OrderType"
                                        :items="order_types"
                                        :item-text="'OrderType'"
                                        :item-value="'OrderTypeID'"
                                        label="Order Type"
                                        class="mx-3"
                                        auto-select-first
                                    ></v-combobox>
                                </div>
                                <div class="tm2">
                                    <v-combobox
                                        dense
                                        hide-details
                                        v-model="editedItem.SplitType"
                                        :items="split_types"
                                        :item-text="'SplitTypeName'"
                                        :item-value="'SplitTypeID'"
                                        label="Split Type"
                                        class="mx-3"
                                        auto-select-first
                                    ></v-combobox>
                                </div>
                                <div class="tm2">
                                    <v-combobox
                                        dense
                                        hide-details
                                        v-model="editedItem.NoLoadType"
                                        :items="no_load_types"
                                        :item-text="'NoLoadTypeName'"
                                        :item-value="'NoLoadTypeID'"
                                        label="No Load Type"
                                        class="mx-3"
                                        auto-select-first
                                    ></v-combobox>
                                </div>
                            </v-row>
                            <v-row class="mx-5">
                                <v-row>
                                    <v-col cols="6">
                                        <v-textarea
                                            dense
                                            hide-details
                                            v-model="
                                                editedItem.DispatchComments
                                            "
                                            label="Dispatch Comments"
                                            class="mx-3"
                                            rows="4"
                                            no-resize
                                        ></v-textarea>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-textarea
                                            dense
                                            hide-details
                                            class="mx-3"
                                            rows="4"
                                            label="Special Instructions"
                                            v-model="
                                                editedItem.SpecialInstructions
                                            "
                                            no-resize
                                        ></v-textarea>
                                    </v-col>
                                </v-row>
                            </v-row>
                            <!-- <v-row class="ma-5 py-5">
                                    <v-btn
                                        v-if="isModal != 'true'"
                                        dark
                                        color="secondary"
                                        class="mx-3 white--text"
                                        @click="validate()"
                                    >
                                        Save
                                        <v-icon right dark>mdi-content-save</v-icon>
                                    </v-btn>
                                    <v-btn
                                        v-if="isModal != 'true'"
                                        exact
                                        dark
                                        color="secondary"
                                        class="mr-3 white--text"
                                        @click="cancel()"
                                    >
                                        Close
                                        <v-icon right dark>mdi-close</v-icon>
                                    </v-btn>
                            </v-row> -->
                        </v-card-text>
                    </v-card>
                    <v-btn
                        color="indigo"
                        outlined
                        @click="newAssignment.currentStep = 1"
                    >
                        <v-icon>mdi-arrow-left</v-icon>
                        Go back
                    </v-btn>
                    <v-btn
                        color="indigo"
                        outlined
                        style="margin: 0 10px;"
                        @click="validate()"
                    >
                        Continue
                        <v-icon>mdi-arrow-right</v-icon>
                    </v-btn>
                    <v-btn
                        text
                        @click="$store.state.order.rdnAdd = false"
                        color="indigo"
                    >
                        Cancel
                    </v-btn>
                </v-stepper-content>

                <v-stepper-step
                    :complete="newAssignment.currentStep > 3"
                    step="3"
                >
                    Set the order position
                </v-stepper-step>

                <v-stepper-content step="3">
                    <v-card class="mb-12" outlined>
                        <v-card-title class="headline">
                            Order overview for
                            {{ newAssignment.shiftSelected.DriverName }}
                        </v-card-title>
                        <p style="margin-left: 20px;">
                            <strong>Truck:</strong>
                            {{ newAssignment.shiftSelected.Truck }}
                        </p>
                        <p style="margin-left: 20px;">
                            <strong>Trailer:</strong>
                            {{ newAssignment.shiftSelected.Trailer }}
                        </p>
                        <v-row
                            v-for="order in newAssignment.shiftSelected
                                .localOrderConfiguration"
                            :key="order.OrderID"
                            style="margin: 10px;"
                        >
                            <v-col cols="2">
                                <v-text-field
                                    v-model="order.LoadNum"
                                    label="LoadNum"
                                    outlined
                                    dense
                                    hide-details
                                    @change="updateOrderByGlen(order)"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field
                                    v-model="order.LoadNumOrd"
                                    label="LoadNumOrd"
                                    outlined
                                    dense
                                    hide-details
                                    @change="updateOrderByGlen(order)"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field
                                    v-model="order.StationNumber"
                                    label="SiteNumber"
                                    outlined
                                    readonly
                                    dense
                                    hide-details
                                ></v-text-field>
                            </v-col>
                            <v-col
                                cols="auto"
                                v-for="product in order.Products.products"
                                :key="product.ProductID"
                            >
                                <v-text-field
                                    v-model="product.Quantity"
                                    :label="product.Product"
                                    outlined
                                    dense
                                    hide-details
                                    readonly
                                    :prepend="product.Product"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <!-- <v-card-title style="max-width: 70%;">
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                        color="indigo"
                                        dark
                                        v-bind="attrs"
                                        v-on="on"
                                        @click="showCheckboxes = !showCheckboxes"
                                    >
                                        {{
                                            showCheckboxes ? 'mdi-checkbook-arrow-left' : 'mdi-checkbook-arrow-right'
                                        }}
                                    </v-icon>
                                </template>
                                <span>
                                    {{
                                        showCheckboxes ? 'Hide checkboxes' : 'Show checkboxes'
                                    }}
                                </span>
                            </v-tooltip>
                            <v-spacer></v-spacer>
                            <v-btn
                                v-if="showCheckboxes"
                                color="indigo"
                                outlined
                                dense
                                small
                                style="margin: 0 10px;"
                                @click="splitOrders"
                            >
                                Split orders
                                <v-icon>mdi-set-split</v-icon>
                            </v-btn>
                        </v-card-title>
                        <div v-if="updateOrderConfiguration" class="spinner">
                            <div class="sk-chase">
                                <div class="sk-chase-dot"></div>
                                <div class="sk-chase-dot"></div>
                                <div class="sk-chase-dot"></div>
                                <div class="sk-chase-dot"></div>
                                <div class="sk-chase-dot"></div>
                                <div class="sk-chase-dot"></div>
                            </div>
                        </div>
                        <v-list v-else>
                            <draggable
                                v-model="newAssignment.shiftSelected.localOrderConfiguration"
                                @update="changeLocalOrderConfiguration"
                                group="orders"
                                ghost-class="ghost"
                                style="min-height: 200px;max-width: 70%;cursor: grab;"
                            >
                                <div
                                    v-for="order in newAssignment.shiftSelected.localOrderConfiguration"
                                    :key="order.OrderID"
                                    style="font-size: 10.5px;border-bottom: 1px solid lightgrey;"
                                >
                                    <v-list-item
                                        v-bind:key="order.OrderID"
                                        :style="
                                            order.OrderID == 'new-ord' ?
                                            'margin-bottom: 1px; background-color: #d5f5e3;' :
                                            'margin-bottom: 1px; background-color: #fff;'
                                        "
                                    >
                                        <div style="margin-right: 20px;" v-if="showCheckboxes">
                                            <v-checkbox
                                                v-model="order.ModelSplit"
                                                color="indigo"
                                                hide-details
                                                dense
                                            ></v-checkbox>
                                        </div>
                                        <div style="margin-right: 20px;">
                                            <v-chip
                                                class="ma-2"
                                                color="indigo"
                                                outlined
                                                small
                                                text-color="indigo"
                                            >
                                                <v-icon left>
                                                    mdi-pound
                                                </v-icon>
                                                {{ order.OrderID }}
                                            </v-chip>
                                        </div>
                                        <div style="margin-right: 20px;">
                                            <v-chip
                                                class="ma-2"
                                                color="indigo"
                                                outlined
                                                label
                                                small
                                                text-color="indigo"
                                            >
                                                <v-icon left>
                                                    mdi-format-list-numbered
                                                </v-icon>
                                                {{
                                                    order.LoadNumOrd == null ? order.LoadNum :
                                                    order.LoadNum + ' . ' + order.LoadNumOrd
                                                }}
                                            </v-chip>
                                        </div>
                                        <div style="margin-right: 20px;">
                                            <v-chip
                                                class="ma-2"
                                                color="indigo"
                                                outlined
                                                label
                                                small
                                                text-color="indigo"
                                            >
                                                <v-icon left>
                                                    mdi-shape
                                                </v-icon>
                                                {{ order.OrderStatus }}
                                            </v-chip>
                                        </div>
                                        <div style="margin-right: 20px;">
                                            <v-chip
                                                class="ma-2"
                                                color="indigo"
                                                outlined
                                                label
                                                small
                                                text-color="indigo"
                                            >
                                                <v-icon left>
                                                    mdi-fuel
                                                </v-icon>
                                                Terminal:
                                                {{ getTerminalName(order.Terminal) }}
                                            </v-chip>
                                        </div>
                                        <div style="margin-right: 20px;">
                                            <v-chip
                                                class="ma-2"
                                                color="indigo"
                                                outlined
                                                label
                                                small
                                                text-color="indigo"
                                            >
                                                <v-icon left>
                                                    mdi-gas-station
                                                </v-icon>
                                                Station:
                                                {{ getStationName(order.Station) }}
                                            </v-chip>
                                        </div>
                                    </v-list-item>
                                </div>
                            </draggable>
                        </v-list> -->
                    </v-card>
                    <v-btn
                        color="indigo"
                        outlined
                        @click="newAssignment.currentStep = 2"
                    >
                        <v-icon>mdi-arrow-left</v-icon>
                        Go back
                    </v-btn>
                    <v-btn
                        color="indigo"
                        outlined
                        style="margin: 0 10px;"
                        @click="confirmAndCreateNewOrder"
                    >
                        Confirm and create
                        <v-icon>mdi-note-check</v-icon>
                    </v-btn>
                    <v-btn
                        text
                        @click="$store.state.order.rdnAdd = false"
                        color="indigo"
                    >
                        Cancel
                    </v-btn>
                </v-stepper-content>
            </v-stepper>
        </template>
        <v-container
            grid-list-xs
            fluid
            style="margin-bottom: 0px; padding-bottom: 0px"
            v-else
        >
            <v-toolbar dense dark color="primary">
                <v-spacer></v-spacer>
                <v-toolbar-title class="white--text"
                    >Create New Order</v-toolbar-title
                >
                <v-spacer></v-spacer>
                <v-btn icon @click="$store.state.order.rdnAdd = false"
                    ><v-icon>mdi-close</v-icon></v-btn
                >
            </v-toolbar>
            <SiteReadings
                v-if="show"
                :valores="parmsDT"
                ref="siteRef"
                style="margin-top: 0px; padding-top: 0px"
            />
            <v-card>
                <v-toolbar dense dark color="secondary">
                    <v-spacer></v-spacer>
                    <v-toolbar-title class="white--text"
                        >Order Info</v-toolbar-title
                    >
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row class="mx-5 mt-5">
                    <div class="tm">
                        <v-text-field
                            dense
                            v-model="orderID"
                            label="OrderID"
                            v-if="$store.state.editedOrder.id"
                            disabled
                            class="mx-3"
                        ></v-text-field>
                    </div>
                    <div class="tm">
                        <v-text-field
                            dense
                            v-model="editedItem.OrderStatus"
                            label="Order Status"
                            v-if="$store.state.editedOrder.id"
                            class="mx-3"
                            disabled
                        ></v-text-field>
                    </div>
                    <div class="tm">
                        <v-text-field
                            dense
                            v-model="editedItem.DateOrdered"
                            label="Order Date"
                            class="mx-3"
                            disabled
                        ></v-text-field>
                    </div>
                    <div class="tm">
                        <v-text-field
                            dense
                            v-model="editedItem.TimeOrdered"
                            label="Order Time"
                            class="mx-3"
                            disabled
                        ></v-text-field>
                    </div>
                </v-row>
                <v-form ref="form" lazy-validation>
                    <v-row class="mx-5">
                        <div class="tm">
                            <v-combobox
                                dense
                                hide-details
                                required
                                v-model="editedItem.Station"
                                :items="stations"
                                :item-text="'Name'"
                                :item-value="'id'"
                                label="Station"
                                :rules="[v => !!v || 'Station is required']"
                                class="mx-3"
                                auto-select-first
                                @change="getStationInfo()"
                            ></v-combobox>
                        </div>
                        <div class="tm">
                            <v-combobox
                                dense
                                hide-details
                                required
                                v-model="editedItem.Customer"
                                :items="customers"
                                :item-text="'Name'"
                                :item-value="'id'"
                                label="Customer"
                                :rules="[v => !!v || 'Customer is required ']"
                                class="mx-3"
                                auto-select-first
                            ></v-combobox>
                            <v-row>
                                <v-text-field
                                    label="Ship To"
                                    id="ShipTo"
                                    v-model="editedItem.ShipTo"
                                    :value="editedItem.ShipTo"
                                ></v-text-field>
                            </v-row>
                        </div>
                        <div class="tm">
                            <v-combobox
                                dense
                                hide-details
                                required
                                v-model="editedItem.Terminal"
                                :items="terminals"
                                :item-text="'Name'"
                                :item-value="'id'"
                                :rules="[v => !!v || 'Terminal is required']"
                                label="Terminal"
                                @click:append-outer="savePrimary"
                                append-outer-icon="mdi-content-save"
                                class="mx-3"
                                auto-select-first
                            ></v-combobox>
                        </div>
                        <div class="tm">
                            <v-combobox
                                dense
                                hide-details
                                required
                                v-model="editedItem.Supplier"
                                :items="suppliers"
                                :item-text="'Supplier'"
                                :rules="[v => !!v || 'Supplier is required']"
                                :item-value="'id'"
                                label="Supplier"
                                class="mx-3"
                                auto-select-first
                            ></v-combobox>
                            <v-row class="mx-1">
                                <v-checkbox
                                    style="margin-top: 40px;"
                                    class="mx-3"
                                    large
                                    label="On Price"
                                    v-model="editedItem.onPrice"
                                ></v-checkbox>
                                <v-checkbox
                                    style="margin-top: 40px;"
                                    disabled
                                    class="mx-3"
                                    large
                                    label="Split CK"
                                    v-model="editedItem.SplitApprovedCK"
                                ></v-checkbox>
                                <v-checkbox
                                    style="margin: 0;"
                                    class="mx-3"
                                    large
                                    label="Set Automatic Quantities"
                                    v-model="editedItem.AutomaticCreation"
                                ></v-checkbox>
                            </v-row>
                        </div>
                    </v-row>
                </v-form>
                <v-row class="mx-5">
                    <div class="tm">
                        <v-text-field
                            class="mx-3"
                            label="Loading Number"
                            v-model="editedItem.LoadingNumber"
                        ></v-text-field>
                    </div>
                    <div class="tm">
                        <v-text-field
                            label="Requested Date"
                            id="DateRequested"
                            :value="editedItem.DateRequested"
                            v-mask="'####/##/## ##:##'"
                            :rules="dateRules"
                            type="tel"
                        ></v-text-field>
                    </div>
                    <div class="tm">
                        <v-text-field
                            class="mx-3"
                            label="Created By"
                            disabled
                        ></v-text-field>
                    </div>
                </v-row>
                <v-row class="mx-5">
                    <div class="tm2">
                        <v-combobox
                            dense
                            hide-details
                            v-model="editedItem.OrderType"
                            :items="order_types"
                            :item-text="'OrderType'"
                            :item-value="'OrderTypeID'"
                            label="Order Type"
                            class="mx-3"
                            auto-select-first
                        ></v-combobox>
                    </div>
                    <div class="tm2">
                        <v-combobox
                            dense
                            hide-details
                            v-model="editedItem.SplitType"
                            :items="split_types"
                            :item-text="'SplitTypeName'"
                            :item-value="'SplitTypeID'"
                            label="Split Type"
                            class="mx-3"
                            auto-select-first
                        ></v-combobox>
                    </div>
                    <div class="tm2">
                        <v-combobox
                            dense
                            hide-details
                            v-model="editedItem.NoLoadType"
                            :items="no_load_types"
                            :item-text="'NoLoadTypeName'"
                            :item-value="'NoLoadTypeID'"
                            label="No Load Type"
                            class="mx-3"
                            auto-select-first
                        ></v-combobox>
                    </div>
                </v-row>
                <v-row class="mx-5">
                    <v-row>
                        <v-col cols="6">
                            <v-textarea
                                dense
                                hide-details
                                v-model="editedItem.DispatchComments"
                                label="Dispatch Comments"
                                class="mx-3"
                                rows="4"
                                no-resize
                            ></v-textarea>
                        </v-col>
                        <v-col cols="6">
                            <v-textarea
                                dense
                                hide-details
                                class="mx-3"
                                rows="4"
                                label="Special Instructions"
                                v-model="editedItem.SpecialInstructions"
                                no-resize
                            ></v-textarea>
                        </v-col>
                    </v-row>
                </v-row>
                <v-row class="ma-5 py-5">
                    <v-btn
                        v-if="isModal != 'true'"
                        dark
                        color="secondary"
                        class="mx-3 white--text"
                        @click="validate()"
                    >
                        Save
                        <v-icon right dark>mdi-content-save</v-icon>
                    </v-btn>
                    <v-btn
                        v-if="isModal != 'true'"
                        exact
                        dark
                        color="secondary"
                        class="mr-3 white--text"
                        @click="cancel()"
                    >
                        Close
                        <v-icon right dark>mdi-close</v-icon>
                    </v-btn>
                </v-row>
            </v-card>
        </v-container>

        <v-dialog v-model="dialog" max-width="400px">
            <v-card>
                <v-toolbar color="primary" dense>
                    <v-spacer />
                    <v-toolbar-title class="white--text">
                        Are you sure you want to save changes?</v-toolbar-title
                    >
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-container class="px-10 py-5">
                    <v-row>
                        <v-btn color="success" @click="editOrder()"
                            >Aceptar</v-btn
                        >
                        <v-spacer></v-spacer>
                        <v-btn color="red" @click="dialog = false"
                            >Cancel</v-btn
                        >
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>
    </v-dialog>
</template>

<script>
import axios from 'axios';
import { mask } from 'vue-the-mask';
import moment from 'moment';
import SiteReadings from '../Readings/SiteReadings.vue';
import DynamicToolbar from '../../../Global/Utils/DynamicToolbar.vue';
import trailerView from '../Dispatch/trailerView.vue';
import draggable from 'vuedraggable';

export default {
    name: 'OrdersForm',
    props: ['isModal', 'siteData', 'back', 'CurrentUser', 'DateRange'],

    components: {
        SiteReadings,
        DynamicToolbar,
        trailerView,
        draggable
    },

    directives: {
        mask
    },
    data: function() {
        return {
            dialog: false,
            orderID: this.$store.state.editedOrder.id,
            today: moment(),
            valid: true,
            show: false,
            defaultItem: {
                AutomaticCreation: null,
                Station: '',
                Customer: '',
                Terminal: '',
                Supplier: '',
                LoadingNumber: '',
                DateRequested: '',
                SpecialInstructions: '',
                DispatchComments: '',
                DateOrdered: '',
                TimeOrdered: '',
                ShiftDetail: '',
                Driver: '',
                Truck: '',
                Trailer: '',
                Shift: '',
                ShiftDate: '',
                onPrice: false,
                SplitApprovedCK: false,
                orderProducts: {
                    Product: [],
                    Quantity: []
                },
                SplitType: {
                    SplitTypeName: '',
                    SplitTypeID: 0
                },
                NoLoadType: {
                    NoLoadTypeName: '',
                    NoLoadTypeID: 0
                },
                OrderType: {
                    OrderType: '',
                    OrderTypeID: 0
                }
            },
            parmsDT: [],
            editedItem: {
                AutomaticCreation: null,
                Station: '',
                Customer: '',
                editID: 0,
                Terminal: '',
                Order: [],
                Supplier: '',
                LoadingNumber: '',
                DateRequested: '',
                SpecialInstructions: '',
                DispatchComments: '',
                DateOrdered: '',
                TimeOrdered: '',
                ShiftDetail: '',
                Driver: '',
                Truck: '',
                Trailer: '',
                Shift: '',
                ShiftDate: '',
                onPrice: false,
                SplitApprovedCK: false,
                SplitType: {
                    SplitTypeName: '',
                    SplitTypeID: 0
                },
                NoLoadType: {
                    NoLoadTypeName: '',
                    NoLoadTypeID: 0
                },
                OrderType: {
                    OrderType: '',
                    OrderTypeID: 0
                }
            },
            Cont: 1,
            orderProducts: [],
            deletedProducts: [],
            stations: [],
            customers: [],
            terminals: [],
            suppliers: [],
            split_types: [],
            no_load_types: [],
            order_types: [],
            rows: [0],
            rowCount: 0,
            products: [],
            orderRules: [
                v => !!v || 'This field is required',
                v => (v && v <= 60000) || 'Amount should not be above 60,000'
            ],
            menu: false,
            dateRules: [
                v => !!v || 'This date is required',
                v =>
                    (parseInt(v[5] + v[6]) <= 12 &&
                        parseInt(v[5] + v[6]) > 0) ||
                    'Date Incorrect',
                v =>
                    (parseInt(v[8] + v[9]) <= 31 &&
                        parseInt(v[8] + v[9]) > 0) ||
                    'Date Incorrect'
            ],
            newAssignment: {
                new: false,
                collections: {
                    drivers: [],
                    shifts: []
                },
                driverSelected: null,
                shiftSelected: {
                    Truck: null,
                    Trailer: null,
                    localOrderConfiguration: []
                },
                currentStep: 1
            },
            updateOrderConfiguration: false,
            showCheckboxes: false,
            localSiteRef: null,
            loading: {
                newAssignment: false
            }
        };
    },
    computed: {
        orderTot() {
            return this.orderProducts.reduce(getOrderTotal, 0);

            function getOrderTotal(total, item) {
                var q = parseInt(item.Quantity);
                if (isNaN(q)) {
                    return total + 0;
                } else {
                    return total + q;
                }
            }
        }
    },
    async mounted() {
        this.orderProducts.length = 0;
        console.log('Props: ', this.DateRange, this.CurrentUser);
        this.loadAssignmentCollections();
        await this.loadDataToday();
        await this.loadStations();
        await this.loadCustomers();
        await this.loadTerminals();
        await this.loadSuppliers();
        // await this.loadAllProducts();
        await this.loadOrderData();
        await this.loadSplitTypes();
        await this.loadNoLoadTypes();
        await this.loadOrderTypes();
    },
    watch: {
        '$store.state.editedOrder.id': function() {
            (this.orderProducts = []),
                (this.orderID = this.$store.state.editedOrder.id),
                console.log(this.$store.state.editedOrder.id);
            this.loadOrderData();
        },
        'editedItem.Terminal': function() {
            this.parmsDT.Terminal = this.editedItem.Terminal.id;
        },
        'editedItem.Supplier': function() {
            this.parmsDT.Supplier = this.editedItem.Supplier.id;
        },
        'editedItem.Customer': function() {
            this.parmsDT.Customer = this.editedItem.Customer.id;
        },
        siteData: function() {
            if (this.siteData) {
                console.log(this.siteData);
                this.editedItem.Station = {
                    id: this.siteData.StationID,
                    Name: this.siteData.StationName
                };
                this.getStationInfo();
            }
        }
    },

    methods: {
        loadAssignmentCollections: function() {
            this.loading.newAssignment = true;
            let params = {
                StartDate: this.DateRange.Start,
                EndDate: this.DateRange.End
            };

            axios
                .post(
                    '/shift-detail/assignment/order-creation-from-readings',
                    params,
                    {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    }
                )
                .then(response => {
                    this.newAssignment.collections.drivers =
                        response.data.Drivers;
                    this.newAssignment.collections.shifts =
                        response.data.Shifts;
                    console.log('Response: ', this.newAssignment);
                })
                .catch(function(error) {
                    console.log(error);
                })
                .finally(() => {
                    this.loading.newAssignment = false;
                });
        },
        savePrimary: function() {
            var str = this.$store;
            var params = {
                ContractTerminal: this.editedItem.Terminal.id
            };
            if (
                this.editedItem.Station.id == null ||
                this.editedItem.Terminal.id == null
            ) {
                str.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'Select Terminal and Station'
                });
            } else {
                axios
                    .put('station/' + this.editedItem.Station.id, params, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(response => {
                        console.log(response.data);
                        str.dispatch('setSnackbar', {
                            color: 'success',
                            text: 'Primary Terminal saved successfully'
                        });
                    })
                    .catch(function(error) {
                        console.log(error);
                        if (error.response.status === 403) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text:
                                    'You do not have the permission to use this function.'
                            });
                        }
                        if (error.response.status === 500) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text: 'An error has ocurred, please try again.'
                            });
                        }
                    });
            }
        },
        loadDataToday: function() {
            if (
                this.$store.state.editedOrder.destiny == 1 ||
                this.$store.state.editedOrder.destiny == 2
            ) {
                this.editedItem.DateRequested = this.editedItem.DateOrdered = moment(
                    new Date()
                ).format('YYYY/MM/DD');
            }
            console.log(this.editedItem.DateRequested);
        },
        loadStations: function() {
            this.$store.state.isLoading = true;
            axios
                .get('station/active', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.stations = response.data.data;
                    console.log('Stations: ', this.stations);
                })
                .catch(function(error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        loadCustomers: function() {
            this.$store.state.isLoading = true;
            axios
                .get('customer/active', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.customers = response.data.data;
                })
                .catch(function(error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        loadTerminals: function() {
            this.$store.state.isLoading = true;
            axios
                .get('terminal/active', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.terminals = response.data.data;
                    console.log('Terminals: ', this.terminals);
                })
                .catch(function(error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        loadSuppliers: function() {
            this.$store.state.isLoading = true;
            axios
                .get('supplier/active', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.suppliers = response.data.data;
                })
                .catch(function(error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        loadSplitTypes: function() {
            axios
                .get('split-type', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.split_types = response.data;
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        loadNoLoadTypes: function() {
            axios
                .get('no-load-type', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.no_load_types = response.data;
                    console.log(this.no_load_types);
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        loadOrderTypes: function() {
            axios
                .get('order-type', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.order_types = response.data;
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        loadOrderData: function() {
            this.$store.state.isLoading = true;
            this.editedItem.DateOrdered = moment(new Date()).format(
                'YYYY/MM/DD'
            );
            this.editedItem.TimeOrdered = moment(new Date()).format('HH:mm');
            if (this.siteData) {
                console.log(this.siteData);
                this.editedItem.Station = {
                    id: this.siteData.StationID,
                    Name: this.siteData.StationName
                };
                this.getStationInfo();
            }
            if (this.orderID != null) {
                console.log('loading New order');
                axios
                    .get('order/info/' + this.orderID, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(response => {
                        console.log(response.data.data[0]);
                        this.editedItem.OrderID = response.data.data[0].OrderID;
                        this.editedItem.Station = {
                            id: response.data.data[0].StationID,
                            Name: response.data.data[0].Station
                        };
                        this.editedItem.Customer = {
                            id: response.data.data[0].CustomerID,
                            Name: response.data.data[0].Customer
                        };

                        if (response.data.data[0].isContract) {
                            this.editedItem.Terminal = {
                                id: response.data.data[0].ContractTerminal,
                                Name: response.data.data[0].ContractTerminalName
                            };
                        } else {
                            this.editedItem.Terminal = {
                                id: response.data.data[0].TerminalID,
                                Name: response.data.data[0].Terminal
                            };
                        }
                        this.parmsDT = {
                            Customer: response.data.data[0].CustomerID,
                            Terminal: response.data.data[0].TerminalID,
                            Supplier: response.data.data[0].SupplierID
                        };
                        this.editedItem.Supplier = {
                            id: response.data.data[0].SupplierID,
                            Supplier: response.data.data[0].Supplier
                        };
                        this.editedItem.OrderType = {
                            OrderTypeID: response.data.data[0].OrderTypeID,
                            OrderType: response.data.data[0].OrderType
                        };
                        this.editedItem.SplitType = {
                            SplitTypeID: response.data.data[0].SplitTypeID,
                            SplitTypeName: response.data.data[0].SplitType
                        };
                        this.editedItem.NoLoadType = {
                            NoLoadTypeID: response.data.data[0].NoLoadTypeID,
                            NoLoadTypeName: response.data.data[0].NoLoadType
                        };

                        this.editedItem.LoadingNumber =
                            response.data.data[0].LoadingNumber;
                        this.editedItem.DateRequested =
                            response.data.data[0].DateRequested;
                        this.editedItem.SpecialInstructions =
                            response.data.data[0].SpecialInstructions;

                        this.editedItem.OrderStatus =
                            response.data.data[0].OrderStatus;
                        this.editedItem.DateOrdered =
                            response.data.data[0].DateOrdered;
                        this.editedItem.TimeOrdered =
                            response.data.data[0].TimeOrdered;
                        this.editedItem.DispatchComments =
                            response.data.data[0].DispatchComments;
                        this.editedItem.ShiftDetail =
                            response.data.data[0].ShiftDetail;
                        this.editedItem.ShiftDate =
                            response.data.data[0].ShiftDate;
                        this.editedItem.SplitApprovedCK =
                            response.data.data[0].SplitApprovedCK;
                        this.editedItem.Shift = response.data.data[0].Shift;
                        this.editedItem.Driver = response.data.data[0].Driver;
                        this.editedItem.Trailer = response.data.data[0].Trailer;
                        this.editedItem.Truck = response.data.data[0].Truck;
                        this.editedItem.ShipTo = response.data.data[0].ShipTo;

                        axios
                            .get('order-detail/order/' + this.orderID, {
                                headers: {
                                    Authorization:
                                        'Bearer ' + this.$store.state.token
                                }
                            })
                            .then(response => {
                                for (const i in response.data.data) {
                                    console.log(response.data.data[i]);
                                    var product = {
                                        ProductID:
                                            response.data.data[i].ProductID,
                                        Product: response.data.data[i].Product,
                                        productDetailID:
                                            response.data.data[i].id,
                                        Quantity: response.data.data[i].Quantity
                                    };

                                    this.orderProducts.push(product);
                                }
                                console.log(this.orderProducts);
                                this.loadProducts(this.editedItem.Station.id);
                            })
                            .catch(function(error) {
                                console.log(error);
                            });
                    })
                    .catch(function(error) {
                        console.log(error);
                    });
            }
            if (this.$store.state.editedOrder.StationID != null) {
                this.editedItem.Station = {
                    id: this.$store.state.editedOrder.StationID,
                    Name: this.$store.state.editedOrder.StationName
                };
                this.getStationInfo();
            }
            this.$store.state.isLoading = false;
        },
        getStationInfo: function() {
            //this.$store.state.isLoading = true;
            axios
                .get('order/station/' + this.editedItem.Station.id, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.editedItem.Customer = {
                        id: response.data.data[0].CustomerID,
                        Name: response.data.data[0].Customer
                    };
                    this.editedItem.Terminal = {
                        id: response.data.data[0].TerminalID,
                        Name: response.data.data[0].Terminal
                    };
                    this.editedItem.Supplier = {
                        id: response.data.data[0].SupplierID,
                        Supplier: response.data.data[0].Supplier
                    };
                    this.editedItem.LoadingNumber =
                        response.data.data[0].LoadingNumber;
                    this.loadProducts(this.editedItem.Station.id);
                    this.parmsDT = {
                        Customer: response.data.data[0].CustomerID,
                        Terminal: response.data.data[0].TerminalID,
                        Supplier: response.data.data[0].SupplierID
                    };
                })
                .catch(function(error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        loadProducts: function(station) {
            this.$store.state.isLoading = true;
            axios
                .get('tank/product/' + station, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.products = response.data.data;

                    this.show = true;
                    if (this.products.length == 0) {
                        this.loadAllProducts();
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        loadAllProducts: function() {
            this.$store.state.isLoading = true;
            axios
                .get('product/active', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.products = response.data.data;
                })
                .catch(function(error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        newOrder: function() {
            this.$store.state.isLoading = true;
            var SiteRTHrs = 0;
            var str = this.$store;
            var SiteROHrs = 0;
            if (this.siteData) {
                console.log('Products:');
                console.log(this.$refs.siteRef.products);
                for (var x in this.$refs.siteRef.products) {
                    if (this.$refs.siteRef.RTHrs[x]) {
                        if (x == 0) {
                            SiteRTHrs = this.$refs.siteRef.RTHrs[x];
                        }
                        if (this.$refs.siteRef.RTHrs[x] > SiteRTHrs) {
                            SiteRTHrs = this.$refs.siteRef.RTHrs[x];
                        }
                    }

                    if (this.$refs.siteRef.products[x].ROHrs) {
                        if (x == 0) {
                            SiteROHrs = this.$refs.siteRef.products[x].ROHrs;
                        }
                        if (this.$refs.siteRef.products[x].ROHrs < SiteROHrs) {
                            SiteROHrs = this.$refs.siteRef.products[x].ROHrs;
                        }
                    }
                }
                var day = new Date(
                    this.$refs.siteRef.readings[0].DateTime
                ).getTime();
                var ROTime = new Date(day + SiteROHrs * 3600000);
                var RTTime = new Date(day + SiteRTHrs * 3600000);
            } else {
                this.$store.state.editedOrder.destiny = 1;
            }
            var params = {
                AutomaticCreation: this.editedItem.AutomaticCreation,
                Station: this.editedItem.Station.id,
                Customer: this.editedItem.Customer.id,
                Terminal: this.editedItem.Terminal.id,
                Supplier: this.editedItem.Supplier.id,
                DateRequested: this.getMsk('DateRequested'),
                TimeOrdered: this.editedItem.TimeOrdered,
                DateOrdered: this.editedItem.DateOrdered,
                LoadingNumber: this.editedItem.LoadingNumber,
                SpecialInstructions: this.editedItem.SpecialInstructions,
                DispatchComments: this.editedItem.DispatchComments,
                SplitTypeID: this.editedItem.SplitType.SplitTypeID,
                NoLoadTypeID: this.editedItem.NoLoadType.NoLoadTypeID,
                OrderTypeID: this.editedItem.OrderType.OrderTypeID,
                ReadyForDispatch: 1,
                ROHrs: SiteROHrs,
                RTHrs: SiteRTHrs,
                ROTime: moment(ROTime).format('YYYY-MM-DD HH:mm:ss'),
                RTTime: moment(RTTime).format('YYYY-MM-DD HH:mm:ss'),
                ShipTo: this.editedItem.ShipTo
            };

            let url = 'order';
            if (this.newAssignment.new) {
                url = 'order/order-by-glen';

                params.ShiftDetail = this.editedItem.ShiftDetail;
                params.OrderStatus = this.editedItem.OrderStatus;
                params.LoadNum = this.editedItem.LoadNum;
                params.LoadNumOrd = this.editedItem.LoadNumOrd;
            }

            console.log('params: ', params);
            console.log('url: ', url);
            let refTest = this.$refs.siteRef;
            // this.localSiteRef = this.$refs.siteRef;
            console.log('Local site ref: ', this.localSiteRef);
            axios
                .post(url, params, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(async response => {
                    console.log('New order created: ', response.data);
                    console.log('Ref: ', refTest);
                    await this.newOrderDetails(response.data.OrderID);
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        newOrderDetails: async function(OrderID) {
            this.$store.state.isLoading = true;
            var str = this.$store;
            console.log('SiteRef: ', this.localSiteRef);
            console.log('SiteData: ', this.siteData);
            if (!this.siteData) {
                for (const i in this.orderProducts) {
                    if (this.orderProducts[i].Product.ProductID != null) {
                        var params = {
                            OrderID: OrderID,
                            ProductType: this.orderProducts[i].Product
                                .ProductID,
                            ProductQuantity: this.orderProducts[i].Quantity,
                            DispatchedQuantity: this.orderProducts[i].Quantity
                        };
                        console.log('Params for product details: ', params);
                        await this.createProductDetail(params);
                    }
                }
            } else {
                console.log('Else: ', this.localSiteRef);
                for (const i in this.localSiteRef.products) {
                    if (this.localSiteRef.products[i].ProductID != null) {
                        var siteParams = {
                            OrderID: OrderID,
                            ProductType: this.localSiteRef.products[i]
                                .ProductID,
                            ProductQuantity: this.localSiteRef.products[i]
                                .Quantity,
                            ProductCode: this.localSiteRef.products[i]
                                .ProductCode,
                            DispatchedQuantity: this.localSiteRef.products[i]
                                .Quantity
                        };
                        console.log(this.localSiteRef.products[i].Quantity);
                        if (
                            this.localSiteRef.products[i].Quantity > 0 &&
                            this.localSiteRef.products[i].Quantity != ''
                        ) {
                            console.log('Params else: ', siteParams);
                            await this.createProductDetail(siteParams);
                        }
                    }
                }
            }

            str.dispatch('setSnackbar', {
                color: 'success',
                text: 'Order added successfully '
            });
            this.$store.state.isLoading = false;

            if (this.newAssignment.new) {
                this.$emit('close');
                this.newAssignment.new = false;
            }

            this.$store.state.order.rdnAdd = false;
        },
        editOrder: function() {
            this.$store.state.isLoading = true;
            var str = this.$store;
            var params = {
                Station: this.editedItem.Station.id,
                Customer: this.editedItem.Customer.id,
                Terminal: this.editedItem.Terminal.id,
                Supplier: this.editedItem.Supplier.id,
                DateRequested: this.getMsk('DateRequested'),
                LoadingNumber: this.editedItem.LoadingNumber,
                SpecialInstructions: this.editedItem.SpecialInstructions,
                DispatchComments: this.editedItem.DispatchComments,
                SplitTypeID: this.editedItem.SplitType.SplitTypeID,
                OrderTypeID: this.editedItem.OrderType.OrderTypeID,
                NoLoadTypeID: this.editedItem.NoLoadType.NoLoadTypeID,
                ShipTo: this.editedItem.ShipTo
            };
            console.log(params);
            axios
                .put('order/' + this.orderID, params, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.editID = response.data.OrderID;
                    this.editOrderDetails(this.editID);
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },

        editOrderDetails: function(OrderID) {
            var str = this.$store;
            for (const i in this.orderProducts) {
                var orderDetailID = this.orderProducts[i].productDetailID;
                var params = {};
                console.log(orderDetailID);
                if (this.orderProducts[i].Product.ProductID != null) {
                    params = {
                        OrderID: OrderID,
                        ProductType: this.orderProducts[i].Product.ProductID,
                        ProductQuantity: this.orderProducts[i].Quantity,
                        DispatchedQuantity: this.orderProducts[i].Quantity
                    };
                } else {
                    params = {
                        OrderID: OrderID,
                        ProductType: this.orderProducts[i].ProductID,
                        ProductQuantity: this.orderProducts[i].Quantity,
                        DispatchedQuantity: this.orderProducts[i].Quantity
                    };
                }
                if (orderDetailID != undefined) {
                    console.log('Editing a new product', params);
                    this.updateProductDetail(params, orderDetailID);
                } else {
                    console.log('Creating a new product', params);
                    this.createProductDetail(params);
                }
            }
            if (this.deletedProducts.length > 0) {
                for (const j in this.deletedProducts) {
                    axios
                        .delete('order-detail/' + this.deletedProducts[j], {
                            headers: {
                                Authorization:
                                    'Bearer ' + this.$store.state.token
                            }
                        })
                        .then(response => {
                            console.log(response);
                            str.dispatch('setSnackbar', {
                                color: 'success',
                                text: 'Order added successfully'
                            });
                        })
                        .catch(function(error) {
                            console.log(error);
                            if (error.response.status === 403) {
                                str.dispatch('setSnackbar', {
                                    color: 'error',
                                    text:
                                        'You do not have the permission to use this function.'
                                });
                            }
                            if (error.response.status === 500) {
                                str.dispatch('setSnackbar', {
                                    color: 'error',
                                    text:
                                        'An error has ocurred, please try again.'
                                });
                            }
                        });
                }
            }

            this.$store.state.isLoading = false;
        },

        async createProductDetail(params) {
            // this.$store.state.isLoading = true;
            var str = this.$store;

            let url = 'order-detail';
            if (this.newAssignment.new) {
                url = 'order-detail/order-detail-by-glen';
            }

            await axios
                .post(url, params, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    // str.dispatch('setSnackbar', {
                    //     color: 'success',
                    //     text: 'Order added successfully '
                    // });
                    this.dialog = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
            // this.$store.state.isLoading = false;
        },

        updateProductDetail(params, id) {
            this.$store.state.isLoading = true;
            var str = this.$store;
            axios
                .put('order-detail/' + id, params, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    console.log(response.data);
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Order added successfully'
                    });
                    this.dialog = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },
        copyOrder: function() {
            // create order copy
            var params = {
                OrderStatus: 'ACTIVE',
                Station: this.editedItem.Station.id,
                Customer: this.editedItem.Customer.id,
                Terminal: this.editedItem.Terminal.id,
                Supplier: this.editedItem.Supplier.id,
                DateRequested: this.editedItem.DateRequested,
                LoadingNumber: this.editedItem.LoadingNumber,
                SpecialInstructions: this.editedItem.SpecialInstructions,
                ReadyForDispatch: 1
            };
            console.log(params);
            var newOrderID = 0;
            var str = this.$store;
            axios
                .post('order', params, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    newOrderID = response.data.OrderID;
                    console.log('NewOrder', response.data);
                    console.log('NewOrder', newOrderID);
                    this.$store.state.order.view = true;
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Successful Duplicate Order '
                    });
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });

            // create order details copy
            axios
                .get('order-detail/order/' + this.$store.state.editedOrder.id, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    for (const i in response.data.data) {
                        var params = {
                            OrderID: newOrderID,
                            ProductType: response.data.data[i].ProductID,
                            ProductQuantity: response.data.data[i].Quantity,
                            DispatchedQuantity: response.data.data[i].Quantity
                        };
                        axios
                            .post('order-detail', params, {
                                headers: {
                                    Authorization:
                                        'Bearer ' + this.$store.state.token
                                }
                            })
                            .then(response => {
                                console.log(response);
                                this.$store.state.editedOrder.id = newOrderID;
                            })
                            .catch(function(error) {
                                console.log(error);
                                if (error.response.status === 403) {
                                    str.dispatch('setSnackbar', {
                                        color: 'error',
                                        text:
                                            'You do not have the permission to use this function.'
                                    });
                                }
                                if (error.response.status === 500) {
                                    str.dispatch('setSnackbar', {
                                        color: 'error',
                                        text:
                                            'An error has ocurred, please try again.'
                                    });
                                }
                            });
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        save: function() {
            if (this.orderID > 1) {
                console.log('OrderID: ', this.orderID);
                this.dialog = true;
            } else {
                console.log('New order', this.orderID);
                this.newOrder();
            }
        },
        deleteOrder: function() {
            console.log(this.$store.state.editedOrder.id);
            var str = this.$store;
            this.$store.state.isLoading = true;
            axios
                .delete('order/' + this.$store.state.editedOrder.id, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    console.log(response);
                    this.$store.state.order.view = true;
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Order removed successfully.'
                    });

                    this.$store.state.order.edt = false;
                    this.$store.state.order.view = true;
                })
                .catch(function(error) {
                    console.log(error.response);
                    console.log(error.response.status);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                    if (error.response.status == 405) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'Failed to delete order, already dispatched.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },
        cancel: function() {
            this.$store.state.order.rdnAdd = false;
        },
        test: function() {
            console.log(this.$refs.siteRef.products);
        },

        checkArray(i) {
            console.log(i);
            console.log(this.orderProducts.Product);
        },

        validate() {
            var str = this.$store;
            if (this.$refs.form.validate() == false) {
                this.$refs.form.validate();
            } else {
                if (
                    this.editedItem.Station.id == null ||
                    this.editedItem.Customer.id == null ||
                    this.editedItem.Terminal.id == null ||
                    this.editedItem.Supplier.id == null
                ) {
                    str.dispatch('setSnackbar', {
                        color: 'error',
                        text:
                            'Please make sure option is selected (Station, Terminal, Customer, Supolier)'
                    });
                } else {
                    this.localSiteRef = this.$refs.siteRef;
                    if (
                        this.CurrentUser == 'glarivee' ||
                        this.CurrentUser == 'fchavarin'
                    ) {
                        console.log('Local site ref: ', this.localSiteRef);
                        this.setLocalOrderConfiguration();
                    } else {
                        this.save();
                    }
                }
            }
        },
        getMsk: function(id) {
            return document.getElementById(id).value;
        },
        confirmAndCreateNewOrder: function() {
            let str = this.$store;
            console.log('Confirm and create');
            console.log(this.newAssignment);
            let order = this.newAssignment.shiftSelected.localOrderConfiguration.filter(
                ord => ord.OrderID == 'new-ord'
            );
            let orderStatus = order[0].OrderStatus;
            let loadNum = order[0].LoadNum;
            let loadNumOrd =
                order[0].LoadNumOrd == '' ? null : order[0].LoadNumOrd;
            let shiftDetail = this.newAssignment.shiftSelected.ShiftDetail;
            this.newAssignment.new = true;

            this.editedItem.ShiftDetail = shiftDetail;
            this.editedItem.OrderStatus = orderStatus;
            this.editedItem.LoadNum = loadNum;
            this.editedItem.LoadNumOrd = loadNumOrd;

            this.newOrder();
        },
        loadTrailerInfo: function() {
            this.$store.state.dispatch.shift = this.newAssignment.shiftSelected.ShiftDetail;
            this.$store.state.dispatch.trailerID = this.newAssignment.shiftSelected.TrailerId;
            this.$store.state.dispatch.canvas = true;
            this.newAssignment.currentStep = 2;
        },
        setLocalOrderConfiguration: function() {
            console.log('Local order configuration: ', this.newAssignment);
            console.log('Quantities: ', this.localSiteRef);
            let tempOrders = [];
            for (let order of this.newAssignment.shiftSelected.orders_by_glen) {
                tempOrders.push({
                    OrderID: order.OrderID,
                    Terminal: order.Terminal,
                    Station: order.Station,
                    OrderStatus: order.OrderStatus,
                    LoadNum: order.LoadNum,
                    LoadNumOrd: order.LoadNumOrd,
                    ModelSplit: false,
                    Products: order.order_details_glen,
                    StationNumber: order.StationNumber
                });
            }

            let lastLoadNum = 0;
            if (tempOrders.length) {
                lastLoadNum = parseInt(
                    tempOrders[tempOrders.length - 1].LoadNum
                );
            }
            let newOrder = {
                OrderID: 'new-ord',
                Terminal: this.editedItem.Terminal.id,
                Station: this.editedItem.Station.id,
                OrderStatus: 'DISPATCHED',
                LoadNum: lastLoadNum + 1,
                LoadNumOrd: null,
                ModelSplit: false,
                Products: this.localSiteRef,
                StationNumber: this.siteData.SiteNum
            };

            tempOrders.push(newOrder);
            this.newAssignment.shiftSelected.localOrderConfiguration = tempOrders;
            console.log(
                this.newAssignment.shiftSelected.localOrderConfiguration
            );
            this.newAssignment.currentStep = 3;
        },
        changeLocalOrderConfiguration: function() {
            this.updateOrderConfiguration = true;
            console.log('Change local order configuration');
            console.log(
                this.newAssignment.shiftSelected.localOrderConfiguration
            );

            // Change load index locally
            let orders = this.newAssignment.shiftSelected
                .localOrderConfiguration;
            let idx = 0;
            for (let order of orders) {
                order.LoadNum = ++idx;
            }
            this.newAssignment.shiftSelected.localOrderConfiguration = orders;

            this.updateOrderConfiguration = false;
        },
        getTerminalName: function(terminalId) {
            // console.log(this.terminals);
            let terminal = this.terminals.filter(t => {
                return t.id == terminalId;
            });
            console.log(terminal);
            return terminal[0].Name;
        },
        getStationName: function(stationId) {
            // console.log(this.stations);
            let station = this.stations.filter(s => {
                return s.id == stationId;
            });
            console.log(station);
            return station[0].Name;
        },
        splitOrders: function() {
            let str = this.$store;
            console.log(
                this.newAssignment.shiftSelected.localOrderConfiguration
            );
            let orders = this.newAssignment.shiftSelected
                .localOrderConfiguration;
            let ordersToBeSplit = orders.filter(ord => ord.ModelSplit);
            console.log('Orders to be split: ', ordersToBeSplit);
            let idx = 0;
            for (let order of ordersToBeSplit) {
                if (idx < ordersToBeSplit.length - 1) {
                    if (
                        typeof ordersToBeSplit[idx + 1] !== 'undefined' &&
                        ordersToBeSplit[idx + 1].LoadNum == order.LoadNum + 1
                    ) {
                        idx++;
                        continue;
                    } else {
                        str.dispatch('setSnackbar', {
                            color: 'warning',
                            text: 'Orders must be subsequent'
                        });
                        return;
                    }
                }
            }
            console.log('Orders are subsequent');

            // Split orders
            let loadNum = ordersToBeSplit[0].LoadNum;
            let loadNumOrd = 0;
            for (let ord of ordersToBeSplit) {
                ord.LoadNum = loadNum;
                ord.LoadNumOrd = ++loadNumOrd;
                ord.ModelSplit = false;

                for (let order of this.newAssignment.shiftSelected
                    .localOrderConfiguration) {
                    if (order.OrderID == ord.OrderID) {
                        order = ord;
                    }
                }
            }

            console.log(
                'After split: ',
                this.newAssignment.shiftSelected.localOrderConfiguration
            );
        },
        updateOrderByGlen(order) {
            console.log('Order: ', order);
            if (order.OrderID == 'new-ord') {
                str.dispatch('setSnackbar', {
                    color: 'success',
                    text: 'Successfully updated!'
                });
                return;
            }

            let params = {
                OrderID: order.OrderID,
                LoadNum: order.LoadNum,
                LoadNumOrd: order.LoadNumOrd
            };

            var str = this.$store;
            axios
                .put('order/update/order-by-glen', params, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log('Response: ', response.data);
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Successfully updated!'
                    });
                })
                .catch(function(error) {
                    console.log(error);
                });
        }
    }
};
</script>
<style>
.tm {
    width: 25%;
}
.tm2 {
    width: 33.3%;
}
.tm3 {
    width: 15%;
}
.tm5 {
    width: 50%;
}
.tm35 {
    width: 35%;
}
.tm65 {
    width: 65%;
}
.pdr .v-text-field__details {
    display: none;
}
/* .pdr {
    font-size: 10px;
} */

.spinner {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 50px;
}

.sk-chase {
    width: 40px;
    height: 40px;
    position: relative;
    animation: sk-chase 2.5s infinite linear both;
}

.sk-chase-dot {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    animation: sk-chase-dot 2s infinite ease-in-out both;
}

.sk-chase-dot:before {
    content: '';
    display: block;
    width: 25%;
    height: 25%;
    background-color: #4f83cc;
    border-radius: 100%;
    animation: sk-chase-dot-before 2s infinite ease-in-out both;
}

.sk-chase-dot:nth-child(1) {
    animation-delay: -1.1s;
}

.sk-chase-dot:nth-child(2) {
    animation-delay: -1s;
}

.sk-chase-dot:nth-child(3) {
    animation-delay: -0.9s;
}

.sk-chase-dot:nth-child(4) {
    animation-delay: -0.8s;
}

.sk-chase-dot:nth-child(5) {
    animation-delay: -0.7s;
}

.sk-chase-dot:nth-child(6) {
    animation-delay: -0.6s;
}

.sk-chase-dot:nth-child(1):before {
    animation-delay: -1.1s;
}

.sk-chase-dot:nth-child(2):before {
    animation-delay: -1s;
}

.sk-chase-dot:nth-child(3):before {
    animation-delay: -0.9s;
}

.sk-chase-dot:nth-child(4):before {
    animation-delay: -0.8s;
}

.sk-chase-dot:nth-child(5):before {
    animation-delay: -0.7s;
}

.sk-chase-dot:nth-child(6):before {
    animation-delay: -0.6s;
}

@keyframes sk-chase {
    100% {
        transform: rotate(360deg);
    }
}

@keyframes sk-chase-dot {
    80%,
    100% {
        transform: rotate(360deg);
    }
}

@keyframes sk-chase-dot-before {
    50% {
        transform: scale(0.4);
    }

    100%,
    0% {
        transform: scale(1);
    }
}
</style>
